module.exports = __webpack_public_path__ + "img/syukyaku-de-back001.6a084d0f.jpg";